import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import KeyActivitiesPage from './pages/KeyActivitiesPage';
import DrivingTrackPage from './pages/DrivingTrackPage';
import AppointmentForm from './components/AppointmentForm';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import DetailsPage from './pages/DetailsPage';
import LMVCoursePage from './pages/LMVCoursePage';
import HMVCoursePage from './pages/HMVCoursePage';
import MotorcycleCoursePage from './pages/MotorcycleCoursePage';
import Administration from "./components/Administration";
import LearnMorePage from "./pages/LearnMorePage";
import GovernmentApproved from './pages/GovernmentApproved';
import Gallery from './components/Gallery';
import RegisterInterestModal from './components/RegisterInterestModal'; 
import DirectorPage from './components/DirectorPage'; 
import ExpertInstructor from './components/ExpertInstructor';
import Credentials from './pages/Credentials';
import CoursesSection from './components/CoursesSection';
import RefresherTraining from "./components/RefresherTraining";
import PreLicenseProgram from "./components/PreLicenseProgram";
import SVPProgram from "./components/SVPProgram";

const App = () => {
  // Modal state to control visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Functions to open and close the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />  {/* Navigation bar */}

        {/* Global "Register Interest" Button */}
        <button className="cta-button fixed-button" onClick={openModal}>
          Register Your Interest
        </button>

        <div className="flex-grow-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/key-activities" element={<KeyActivitiesPage />} />
            <Route path="/drivingtrackpage" element={<DrivingTrackPage />} />
            <Route path="/appointment" element={<AppointmentForm />} />
            <Route path="/details" element={<DetailsPage />} />
            <Route path="/hmv-course" element={<HMVCoursePage />} />
            <Route path="/lmv-course" element={<LMVCoursePage />} />
            <Route path="/motorcycle-course" element={<MotorcycleCoursePage />} />
            <Route path="/administration" element={<Administration />} />
            <Route path="/learnmorepage" element={<LearnMorePage />} />
            <Route path="/GovernmentApproved" element={<GovernmentApproved />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/DirectorPage" element={<DirectorPage  />} />
            <Route path="/ExpertInstructor" element={<ExpertInstructor />} />
            <Route path="/Credentials" element={< Credentials/>} />
            <Route path="/CoursesSection" element={<CoursesSection/>} />
            <Route path="/RefresherTraining" element={<RefresherTraining/>} />
            <Route path="/PreLicenseProgram" element={<PreLicenseProgram/>} />
            <Route path="/svp-program" element={<SVPProgram />} />
      
          </Routes>
        </div>
        <Footer />

        {/* Register Interest Modal */}
        <RegisterInterestModal isOpen={isModalOpen} onClose={closeModal} />
      </div>
    </Router>
  );
};

export default App;
